import styled from 'styled-components';

export const StyledCarouselContainer = styled.div`
  .ant-carousel .slick-slide {
    justify-content: center;
    align-items: center;
    overflow: hidden;
  }
`;

